export interface ActionButton {
  name: string;
  icon: string;
  action: ActionButtonActionType | string;
  color: string;
  type: ActionButtonType;
  path?: (item: any) => string;
  row?: any;
  index?: number;
  hidded?: (item: any) => boolean;
  disabled?: (item: any) => boolean;
}

export enum ActionButtonType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
}

export enum ActionButtonActionType {
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  FILE = 'FILE',
  VIEW = 'VIEW',
}
